import {
    useCreateTicketTypeMutation,
    useGetArchivedPaginatedTicketTypesMutation,
    useGetPaginatedTicketTypesMutation,
    useToggleArchiveTicketTypeMutation,
    useUpdateTicketTypeMutation
} from '@services/member/list/ticket-types/ticket-types.endpoints';
import { TicketType } from '@services/member/list/ticket-types/ticket-types.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useTicketTypesPageVM = () => {
    const [totalTicketTypes, setTotalTicketTypes] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateTicketType,
        {
            isSuccess: isUpdateTicketTypeSuccess
        }
    ] = useUpdateTicketTypeMutation();

    const [
        createTicketType,
        {
            isSuccess: isCreateTicketTypeSuccess
        }
    ] = useCreateTicketTypeMutation();

    const [
        toggleArchiveTicketType,
        {
            isSuccess: isToggleArchiveTicketTypeSuccess
        }
    ] = useToggleArchiveTicketTypeMutation();

    const handleArchiveTicketTypes = async (lines: TicketType[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce type de ticket ?' : 'Êtes-vous sûr de vouloir désarchiver ce type de ticket ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces types de tickets ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de tickets ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveTicketType({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateTicketTypeSuccess || isUpdateTicketTypeSuccess || isToggleArchiveTicketTypeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateTicketTypeSuccess, isUpdateTicketTypeSuccess, isToggleArchiveTicketTypeSuccess]);

  
    useEffect(() => {
        setTotalTicketTypes(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalTicketTypes(metadata.total);
        }
    };

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedTicketTypesMutation : useGetPaginatedTicketTypesMutation;
    }, [isArchived]);

    return {
        mutationHook,
        totalTicketTypes,
        setTotalTicketTypes,
        isArchived,
        handleMetadata,
        needReload,
        setIsArchived,
        createTicketType,
        updateTicketType,
        handleArchiveTicketTypes,
        MySwal
    };
};
